export default __webpack_public_path__ + "static/media/resolution.9c441423.jpg";